<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <slot name="title" />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <LoadingPanel ref="loadingPanel" />
        <StaticDataTable class="static-table-list">
          <template v-slot:header>
            <tr>
              <th width="25%">Price Group</th>
              <th>Min Size Charge</th>
              <th>Min Price Per Item</th>
              <th>Min Price Per Group</th>
              <th>Min Invoice Charge</th>
            </tr>
          </template>
          <template v-slot:body>
            <tr v-for="priceGroup in customerPriceGroupList" :key="priceGroup.id">
              <td class="font-weight-bold">
                {{priceGroup.name}}
              </td>
              <template v-if="!editing">
                <td>
                  <span class="pricing-list-inherited" v-html="dataDisplayTableArea(priceGroup.minChargeQuantity)" v-if="!isValidNumber(priceGroup.customer.minChargeQuantity)" />
                  <span class="pricing-list-variation" v-html="dataDisplayTableArea(priceGroup.customer.minChargeQuantity)" v-if="isValidNumber(priceGroup.customer.minChargeQuantity)" />
                </td>
                <td>
                  <span v-if="!isValidNumber(priceGroup.customer.minChargeItemPrice)" class="pricing-list-inherited">{{priceGroup.minChargeItemPrice | formatCurrency}}</span>
                  <span v-if="isValidNumber(priceGroup.customer.minChargeItemPrice)" class="pricing-list-variation">{{priceGroup.customer.minChargeItemPrice | formatCurrency}}</span>
                </td>
                <td>
                  <span v-if="!isValidNumber(priceGroup.customer.minChargePrice)" class="pricing-list-inherited">{{priceGroup.minChargePrice | formatCurrency}}</span>
                  <span v-if="isValidNumber(priceGroup.customer.minChargePrice)" class="pricing-list-variation">{{priceGroup.customer.minChargePrice | formatCurrency}}</span>
                </td>
                <td>
                  <span v-if="!isValidNumber(priceGroup.customer.minChargeInvoice)" class="pricing-list-inherited">{{priceGroup.minChargeInvoice | formatCurrency}}</span>
                  <span v-if="isValidNumber(priceGroup.customer.minChargeInvoice)" class="pricing-list-variation">{{priceGroup.customer.minChargeInvoice | formatCurrency}}</span>
                </td>
              </template>
              <template v-if="editing">
                <td>
                  <FormInputText type="number" v-model="priceGroup.customer.minChargeQuantity" @input="valueUpdated" :placeholder="`${priceGroup.minChargeQuantity}`" />
                </td>
                <td>
                  <FormInputCurrency v-model="priceGroup.customer.minChargeItemPrice" @input="valueUpdated" :placeholder="`${priceGroup.minChargeItemPrice}`" />
                </td>
                <td>
                  <FormInputCurrency v-model="priceGroup.customer.minChargePrice" @input="valueUpdated" :placeholder="`${priceGroup.minChargePrice}`" />
                </td>
                <td>
                  <FormInputCurrency v-model="priceGroup.customer.minChargeInvoice" @input="valueUpdated" :placeholder="`${priceGroup.minChargeInvoice}`" />
                </td>
              </template>
            </tr>
          </template>
        </StaticDataTable>
      </div>
    </div>
    </div>
</template>

<script>
import FormMixin from '@/mixins/form'
import DataDisplayMixin from '@/mixins/dataDisplay'

export default {
  name: 'CustomerStockPriceGroupList',
  mixins: [FormMixin, DataDisplayMixin],
  model: {
    event: 'update'
  },
  props: {
    value: Array,
    editing: Boolean
  },
  data() {
    return {
      loading: false,
      stockPriceGroupList: [],
      customerPriceGroupList: []
    }
  },
  watch: {
    value: {
      handler() {
        this.updateList()
      },
      deep: true
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      if(this.$refs.loadingPanel)
        this.$refs.loadingPanel.startLoading()

      this.$apiService.pricingService.getStockPriceGroupList()
      .then(response => {
        this.stockPriceGroupList = response.data

        this.updateList()
      })
      .finally(() => {
        if(this.$refs.loadingPanel)
          this.$refs.loadingPanel.finishedLoading()
      })
      .catch(err => {
        console.error(err)
        if(this.$refs.loadingPanel)
          this.$refs.loadingPanel.setError('Error loading data', err)
      })
    },
    updateList() {
      this.customerPriceGroupList = this.stockPriceGroupList
      .filter(priceGroup => priceGroup.isActive)    // Ignore inactive price groups
      .map(priceGroup => {
        let customerPriceGroupSettings = this.value || []
        let customerConfig = customerPriceGroupSettings.find(customer => customer.stockPriceGroupId == priceGroup.id)

        var output = {
          id: priceGroup.id,
          name: priceGroup.name,
          minChargeQuantity: priceGroup.minChargeQuantity,
          minChargePrice: priceGroup.minChargePrice,
          minChargeItemPrice: priceGroup.minChargeItemPrice,
          minChargeInvoice: priceGroup.minChargeInvoice,
          customer: {
            minChargeQuantity: null,
            minChargePrice: null,
            minChargeInvoice: null              
          }
        }

        if(customerConfig) {
          output.customer = {
            minChargeQuantity: customerConfig.minChargeQuantity,
            minChargePrice: customerConfig.minChargePrice,
            minChargeItemPrice: customerConfig.minChargeItemPrice,
            minChargeInvoice: customerConfig.minChargeInvoice
          }
        }
        return output
      })
    },
    valueUpdated() {
      var priceGroupUpdateList = this.customerPriceGroupList.map(priceGroup => {
        return {
          stockPriceGroupId: priceGroup.id,
          minChargeQuantity: !isNaN(parseFloat(priceGroup.customer.minChargeQuantity)) ? priceGroup.customer.minChargeQuantity : null,
          minChargePrice: !isNaN(parseFloat(priceGroup.customer.minChargePrice)) ? priceGroup.customer.minChargePrice : null,
          minChargeItemPrice: !isNaN(parseFloat(priceGroup.customer.minChargeItemPrice)) ? priceGroup.customer.minChargeItemPrice : null,
          minChargeInvoice: !isNaN(parseFloat(priceGroup.customer.minChargeInvoice)) ? priceGroup.customer.minChargeInvoice : null,
        }
      })

      this.$emit('update', priceGroupUpdateList)
    }
  }
}
</script>